import React, { useContext } from 'react'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import CONTENT from '@/constants/content'
import { useContentful } from '@pcln/contentful-components'
import useContent from '@/hooks/useContent'
import MediaCardComponent from '../MediaCard/MediaCardComponent'
import mediaCardContentsFallback from './content'

export default function VIPPromoMediaCard() {
  const {
    customer: { firstName }
  } = useContext(BootstrapDataContext)

  const leftPromoBox: any = useContentful('leftPromoBox')
  const promo = useContent(leftPromoBox)

  const hasContentfulData = promo != null

  const headlineVIP = firstName
    ? CONTENT.homepage.vip.promo.headlineWithName.replace(
        '{firstName}',
        firstName
      )
    : CONTENT.homepage.vip.promo.headline

  mediaCardContentsFallback.heading = headlineVIP
  const mediaCardContent = hasContentfulData ? promo : mediaCardContentsFallback

  return (
    <>
      <MediaCardComponent content={mediaCardContent} />
    </>
  )
}
